import { render, staticRenderFns } from "./LastServiceSpend.vue?vue&type=template&id=a5bcc312&"
import script from "./LastServiceSpend.vue?vue&type=script&lang=js&"
export * from "./LastServiceSpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports